import {rootApiGroup} from '@integraciones_doc24/wehealthy-api';
import {ApiErrors} from '@integraciones_doc24/wehealthy-api/types/errors';
import {createEditorTokenEndpoint} from '@integraciones_doc24/wehealthy-api/root/editor/createToken';
import {initApiConsumer} from '@urpi/consumer';
import {getBackEnd} from './backEndUrl';

const backendUrl = getBackEnd();

const apiConsumer = initApiConsumer<ApiErrors.All>(
  `${backendUrl}/api`,
  rootApiGroup,
);

const createToken = apiConsumer(createEditorTokenEndpoint);

export const loginUser = async (
  ndi: string,
  password: string,
  brandId: string,
) => {
  try {
    const token = await createToken({
      body: {ndi: ndi, password: password, brandId: brandId},
    });
    return token;
  } catch (e) {
    return 'error';
  }
};
